import { useMutation } from '@apollo/client';
import { loader } from 'graphql.macro';

const addInspectionAttachmentMutation = loader(
  '../../pages/inspection_page/Inspection.addAttachment.graphql',
);
const updateInspectionMutation = loader('./update_inspection_online.graphql');
const updateInspectionItemMutation = loader(
  '../../components/inspections/inspection_items/InspectionItemText.updateInspection.graphql',
);
const addRegretMutation = loader('./add_regret.graphql');
const addParticipantMutation = loader('./add_participant.graphql');
const deleteInspectionMutation = loader('./delete_inspection.graphql');

export const useInspectionMutations = () => {
  const [addInspectionAttachment] = useMutation(
    addInspectionAttachmentMutation,
  );
  const [deleteInspectionOnline] = useMutation(deleteInspectionMutation);
  const [updateInspectionOnline] = useMutation(updateInspectionMutation);
  const [updateInspectionItemOnline] = useMutation(
    updateInspectionItemMutation,
  );
  const [addInspectionRegret] = useMutation(addRegretMutation);
  const [addInspectionParticipant] = useMutation(addParticipantMutation);
  const addAttachment = async ({
    inspectionId,
    file,
    onComplete = () => {},
  }) => {
    await addInspectionAttachment({
      variables: { inspectionId, ...file },
    }).then(() => onComplete());
  };

  const updateInspection = async (variables, onComplete = () => {}) => {
    await updateInspectionOnline({
      variables: { ...variables },
    }).then(() => onComplete());
  };

  const updateInspectionItem = async ({
    onComplete = () => {},
    failed = false,
    status = 'PASS',
    value = '',
    id,
  }) =>
    await updateInspectionItemOnline({
      variables: { id, failed, status, value },
    }).then(() => onComplete());

  const addRegret = async ({ onComplete = () => {}, userId, inspectionId }) =>
    await addInspectionRegret({
      variables: { userId, inspectionId, regretableType: 'inspection' },
    }).then(() => onComplete());

  const addParticipant = async ({
    onComplete = () => {},
    userId,
    inspectionId,
  }) => {
    await addInspectionParticipant({
      variables: { userId, inspectionId },
    }).then(() => onComplete());
  };

  const deleteInspection = async ({ onComplete = () => {}, id }) => {
    await deleteInspectionOnline({ variables: { id } }).then(() =>
      onComplete(),
    );
  };

  return {
    addAttachment,
    updateInspection,
    updateInspectionItem,
    addRegret,
    addParticipant,
    deleteInspection,
  };
};
